<template>
  <v-lazy-image :src="src" :srcPlaceholder="srcPlaceholder" :alt="alt" />
</template>

<script>
import VLazyImage from 'v-lazy-image/v2';

export default {
  name: 'LazyImage',
  components: {
    VLazyImage
  },
  props: {
    src: String,
    srcPlaceholder: String,
    alt: String
  }
};
</script>

<style lang="sass" scoped>
.v-lazy-image
  filter: blur(10px)
  transition: filter 400ms

.v-lazy-image-loaded
  filter: blur(0)
</style>
